module.exports = __webpack_public_path__ + "img/ASGS-Logo-rgb.be04fc4c.webp";